module.exports = __webpack_public_path__ + "static/media/practice-question-divider.5f67c25d.png";